import { Select } from '@truepill/react-capsule'
import { getAdornment } from '../CreateRuleSetPage'

const ARRAY_METHOD_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Some', value: 'some' },
]

const ArrayMethodSelect = ({
  value,
  onChange,
  state,
  helperText,
}: {
  value: string
  onChange: (val: string) => void
  state: 'error' | 'default'
  helperText?: string
}) => {
  return (
    <Select
      label="Array Method"
      value={ARRAY_METHOD_OPTIONS.find(opt => opt.value === value) || null}
      onChange={selected => {
        if (!selected) return
        onChange(selected.value)
      }}
      options={ARRAY_METHOD_OPTIONS}
      selectedKey="label"
      state={state}
      helperText={helperText}
      endAdornment={getAdornment(
        'Select "all": if all values in the field must match the target values. Select "some" if only some of them need to match.',
      )}
    />
  )
}

export default ArrayMethodSelect
